import React from "react";
import classnames from "classnames";
import { navigationPropType } from "@template/state/modules/navigation";
import NavAnchor from "@template/components/Navigation/NavAnchor";
import { createIdAriaDescribedBy } from "@template/helpers/navigationAccessibility";
import styles from "../index.css";

const cx = classnames.bind(styles);

const makeUl = headerId => (items, i) => (
  <ul aria-labelledby={headerId} key={i} className={styles.textList}>
    {items.map(item => (
      <li key={item.id}>
        <NavAnchor
          className={cx(styles.textLink, {
            [styles.textLink__sale]: item.largeScreenStyleType === "sale",
            [styles.textLink__bold]: item.largeScreenStyleType === "premium"
          })}
          item={item}
          data-testid="text-link"
        >
          {item.label.substring(0, 32)}
        </NavAnchor>
      </li>
    ))}
  </ul>
);

const TextList = ({ item }) => {
  const items = [...item.items];

  const headerId = createIdAriaDescribedBy(item.label);
  const makerUI = makeUl(headerId);
  return makerUI(items);
};

TextList.propTypes = {
  item: navigationPropType.isRequired
};

export default TextList;
